export default __webpack_public_path__ + "static/media/cloud_security_lock_icon.cbf050d6.svg";